export default __webpack_public_path__ + "static/badge-do-2-bold-light-6afcbcc307c6f58f2971af36fec5fb56.png";